





















































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import OutilsItem from "@/components/prescriber/OutilsItem.vue";
import { getConnectedUser } from "@/api/api";
import Subscription from "@/models/Subscription";
import DeptRatioCalculator from '@/components/prescriber/DeptRatioCalculator.vue';
import RentCalculator from '@/components/prescriber/RentCalculator.vue';

import AuthModule from '../../store/AuthModule';
import { BACKEND_URL } from '@/helpers/constants';


@Component({
  components: {
    OutilsItem,
    DeptRatioCalculator,
    RentCalculator
  }
})

export default class Outils extends Vue {
  simActif = "dn";
  memActif = "dn";
  juridiqueActif = "dn";
  assuranceActif = "dn";
  formationActif = "dn";
  simulateurActif = "dn";
  gestionLocActif = "dn";
  cuisineLocActif = "dn";
  ameubleActif = 'dn';
  immoActif = 'dn';
  webActif = 'dn';
  reventeActif = "dn";
  fournisseurActif = "dn";
  collocationMeubleeActif = "dn";
  annualSubscription: boolean = false;
  restricted: boolean = false;
  subscription: Subscription | undefined;



      get firstname() {
                return AuthModule.firstname;
            }


        get lastname() {
            return AuthModule.lastname;
        }

        get logo() {
            return AuthModule.logo;
        }

        get backendUrl() {
            return BACKEND_URL;
        }




  async mounted() {
    // vérifie si le prescriber à un abonnement annuel, on prend forcement le dernier abonnement...
    // @TODO : il faudrait verifier que l'abonnement soit valide en plus de faire la comparaison du nombre de jour d'abonnement.
    await getConnectedUser()
      .then(data => this.subscription = data.data.subscriptions![data.data.subscriptions!.length - 1]);
    const start = new Date(this.subscription!.start_at!);
    const end = new Date(this!.subscription!.end_at!);
    // @ts-ignore
    const diffInDay = (end - start) / 60 / 60 / 24 / 1000;
    console.log(diffInDay)
    if (diffInDay > 364) {
      this.annualSubscription = true;
      this.restricted = false;
    }
  }

  isImmo() {
    return localStorage.getItem('service') == 'immo'
  }

  openJuridiqueItems() { if (this.annualSubscription == true) { this.juridiqueActif = this.juridiqueActif == "dn" ? "" : "dn"; } else { this.restricted = true; } }
  openAssuranceItems() { if (this.annualSubscription == true) { this.assuranceActif = this.assuranceActif == "dn" ? "" : "dn"; } else { this.restricted = true; } }
  openFormationItems() { if (this.annualSubscription == true) { this.formationActif = this.formationActif == "dn" ? "" : "dn"; } else { this.restricted = true; } }
  openSimulateurItems() { if (this.annualSubscription == true) { this.simulateurActif = this.simulateurActif == "dn" ? "" : "dn"; } else { this.restricted = true; } }
  openWebItems() { if (this.annualSubscription == true) { this.webActif = this.webActif == "dn" ? "" : "dn"; } else { this.restricted = true; } }
  openFournisseurItems() { if (this.annualSubscription == true) { this.fournisseurActif = this.fournisseurActif == "dn" ? "" : "dn"; } else { this.restricted = true; } }
  openGestionLocItems() { if (this.annualSubscription == true) { this.gestionLocActif = this.gestionLocActif == "dn" ? "" : "dn"; } else { this.restricted = true; } }
  openCuisineItems() { if (this.annualSubscription == true) { this.cuisineLocActif = this.cuisineLocActif == "dn" ? "" : "dn"; } else { this.restricted = true; } }
  openAmeublementItems() { if (this.annualSubscription == true) { this.ameubleActif = this.ameubleActif == "dn" ? "" : "dn"; } else { this.restricted = true; } }
  openReventeItems() { if (this.annualSubscription == true) { this.reventeActif = this.reventeActif == "dn" ? "" : "dn"; } else { this.restricted = true; } }
  openCollocationMeubleeItems() { if (this.annualSubscription == true) { this.collocationMeubleeActif = this.collocationMeubleeActif == "dn" ? "" : "dn"; } else { this.restricted = true; } }

  openSimItems() { this.simActif = this.simActif == "dn" ? "" : "dn"; }
  openMemoItems() { this.memActif = this.memActif == "dn" ? "" : "dn"; }
  openImmoItems() { this.immoActif = this.immoActif == "dn" ? "" : "dn"; }
}

